import { render, staticRenderFns } from "./addlanguage.vue?vue&type=template&id=470682da"
import script from "./addlanguage.vue?vue&type=script&lang=js"
export * from "./addlanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports